import React, { Component } from 'react';
import { Link } from 'react-router-dom';
var Desc = '';
var Setpad = { paddingLeft: '2%' }
export class LoginHomeLatestUpdates extends Component {
    constructor(props) {
        super(props);
        this.handleSelect = this.handleSelect.bind(this);

    }
    handleSelect(e) {
        window.scrollTo(0, 0);
        
    }
    stingBreakLine(str, length, ending) {

       // str = str.props.dangerouslySetInnerHTML.__html;
        //console.log(str + "," + length);
        if (length == null) {
            length = 100;
        }
        if (ending == null) {
            ending = '...';
        }
        //console.log(str + "," + length);
        if (str.length > length) {
            return str.substring(0, length - ending.length) + ending;
        } else {
            return str;
        }

    };

    GetStringFunction(str, index, ending) {
     //   str = str.props.dangerouslySetInnerHTML.__html;
        var res = str.substring(index, str.length) + ending;
        return res;
    }

    GetDecodedString(DescString) {
        DescString = DescString.toString();
        var ht = DescString.replace(/(<([^>]+)>)/ig, '');
        // console.log(ht);
        return ht;
    }

    renderLatestUpdates = () => {
        return this.props.LatestUpdatesList != null && this.props.LatestUpdatesList.map((item, key) => {
            Desc = this.GetDecodedString(item.description);
            var publicationPlus = typeof item.publication == 'undefined' ? "" : item.publication.replace(/ /g, "+");
            return (
                <div style={{ marginLeft: '3%' }}>

                    <Link onClick={this.handleSelect} to={"/PracticeArea?Id=" + item.topicId + "&name=" + item.topic.replace(/ /g, "+")}>
                        <h3 className="Heading "> <img alt="" src="/../../images/green-arrow.png" />
                            <span style={Setpad}>
                                {item.topic}
                            </span>
                        </h3>
                    </Link>

                    <div class="example">

                        <ul class="cards">
                            <li class="card1">

                                {(() => {
                                    if (item.productTypeId == "1") {
                                        return (
                                            <Link onClick={this.handleSelect} to={"/Journals/" + publicationPlus + "/" + item.productId}><img alt={"Cover Image for " + item.publication} src={"/../../images/books/" + item.imageUrl} className="LatestUpdateImg" /></Link>
                                        )
                                    }
                                    else if (item.productTypeId == "2") {
                                        return (
                                            <Link onClick={this.handleSelect} to={"/Manuals/" + publicationPlus + "/" + item.productId}><img alt={"Cover Image for " + item.publication} src={"/../../images/books/" + item.imageUrl} className="LatestUpdateImg" /></Link>
                                        )
                                    }
                                    else if (item.productTypeId == "3") {
                                        return (
                                            <Link onClick={this.handleSelect} to={"/Encyclopedias/" + publicationPlus + "/" + item.productId}><img alt={"Cover Image for " + item.publication} src={"/../../images/books/" + item.imageUrl} className="LatestUpdateImg" /></Link>
                                        )
                                    }
                                }
                                )()}
                            </li>
                            <li class="card2">
                                {(() => {
                                    if (item.productTypeId == "1") {
                                        return (
                                            <Link onClick={this.handleSelect} to={"/journalarticle/" + publicationPlus + "/" + item.volumes[0].volumeNo + "." + item.volumes[0].issues[0].issueTextNo + "/" + item.docId}>
                                                <h4 className="BookHeading mrgntop" style={{ paddingLeft: '12px' }} dangerouslySetInnerHTML={{ __html: item.title != null ? item.title.substring(0, 80) : "" }}></h4>
                                            </Link>

                                            // <Link onClick={this.handleSelect} to={"/JournalsArticle?prddtlid=" + item.id + "&volid=0 &issid=0 &prdid=" + item.productId}>
                                            //     <h4 className="BookHeading mrgntop" style={{ paddingLeft: '12px' }} dangerouslySetInnerHTML={{ __html: item.title != null ? item.title.substring(0, 80) : "" }}></h4>
                                            // </Link>                                           
                                        )
                                    }
                                    else if (item.productTypeId == "2") {
                                        return (
                                            <Link onClick={this.handleSelect} to={"/ManualChapter/" + publicationPlus + "/" + item.docId}>
                                                <h4 className="BookHeading mrgntop" style={{ paddingLeft: '12px' }} dangerouslySetInnerHTML={{ __html: item.title }}></h4>
                                            </Link>
                                        )
                                    }
                                    else if (item.productTypeId == "3") {
                                        return (
                                            <Link onClick={this.handleSelect} to={"/EncyclopediaChapter/" + publicationPlus + "/" + item.docId}>
                                                <h4 className="BookHeading mrgntop" style={{ paddingLeft: '12px' }} dangerouslySetInnerHTML={{ __html: item.title }}></h4>
                                            </Link>
                                        )
                                    }
                                }
                                )()}
                                {
                                    (Desc == null) ?
                                        <p className="BookBody WidthOfLatestUpdates" style={{ marginBottom: '0px', paddingLeft: '12px', overFlow: 'hidden', whiteSpace: 'initial' }}>The regulatory approach to tech
                                    companies in the internal market is in the process of being rebalanced from maximizing economic ben (22 April)…
                                    </p>
                                        :

                                        <p className="BookBody WidthOfLatestUpdates" style={{ marginBottom: '0px', paddingLeft: '12px', overFlow: 'hidden', whiteSpace: 'initial' }}>
                                            {item.title.length < 38 ? this.stingBreakLine(Desc, 161, ' ') : (item.title.length > 38 && item.title.length < 60) ? this.stingBreakLine(Desc, 125, ' ') : (item.title.length <= 70) ? this.stingBreakLine(Desc, 79, ' ') : this.stingBreakLine(Desc, 76, ' ')} </p>
                                }
                            </li>


                            <li class="card4">
                                <p className="BookBody ">
                                    {item.title.length < 38 ? this.GetStringFunction(Desc, 161, '...') : (item.title.length > 38 && item.title.length < 60) ? this.GetStringFunction(Desc, 124, '...') : (item.title.length <= 70) ? this.GetStringFunction(Desc, 78, ' ') : this.GetStringFunction(Desc, 75, ' ')}
                                </p>
                            </li>

                        </ul>

                    </div>
                </div >
            )
        });
    }

    render() {
        return (
            <div className="row" >
                <div className="col-lg-12">

                    {this.renderLatestUpdates()}
                </div>
            </div>
        )
    }
}

export default LoginHomeLatestUpdates;


// WEBPACK FOOTER //
// ./src/components/LoginHome/LoginHomeLatestUpdates.jsx